<div class="{{ size }}" [ngClass]="{ hint: hint }">
  <span
    class="placeholder text-white"
    [ghs-label]="value"
    [ghs-label-args]="args"
    [ghs-label-args-replace]="argLabel"
    [relative]="relative"
    [style]="style"
  ></span>
</div>
